/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Gmail_Ingest_Attachments_SuccessInputs */

const es_tools_gmail_ingest_attachments_success = /** @type {(inputs: Tools_Gmail_Ingest_Attachments_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adjuntos de Gmail ingestados`)
};

const en_tools_gmail_ingest_attachments_success = /** @type {(inputs: Tools_Gmail_Ingest_Attachments_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gmail attachments ingested`)
};

/**
* | output |
* | --- |
* | "Gmail attachments ingested" |
*
* @param {Tools_Gmail_Ingest_Attachments_SuccessInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_gmail_ingest_attachments_success = /** @type {((inputs?: Tools_Gmail_Ingest_Attachments_SuccessInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Gmail_Ingest_Attachments_SuccessInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_gmail_ingest_attachments_success(inputs)
	return en_tools_gmail_ingest_attachments_success(inputs)
});
export { tools_gmail_ingest_attachments_success as "tools.gmail.ingest_attachments_success" }